import { TransitionComponent } from "./chunk-3HAR27K6.js";

// src/components/Dialog/Dialog.Panel.tsx
import React, { Fragment } from "react";
import clsx from "clsx";
import { Dialog as HeadlessDialog } from "@headlessui/react";
var DialogPanel = _ref => {
  let {
    transition = "appear-from-bottom",
    children,
    className
  } = _ref;
  return /* @__PURE__ */React.createElement(TransitionComponent.Child, {
    variant: transition,
    as: Fragment
  }, /* @__PURE__ */React.createElement(HeadlessDialog.Panel, {
    className: clsx("pd-dialog__panel", className)
  }, children));
};
var Dialog_Panel_default = DialogPanel;
export { Dialog_Panel_default };